import {defineMessages, useIntl} from 'react-intl';
import {css, Icon, view} from '@sail/ui/deprecated';
import {doc} from '@sail/icons/react/Icon';

export const messages = defineMessages({
  dropFile: {
    id: 'conversations_ui.attachments.dropFile',
    description:
      'Label indicating where user can drag and drop a file to upload it',
    defaultMessage: 'Drop file',
  },
});

export const DropFileZone = (): JSX.Element | null => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        backgroundColor: 'container',
        borderRadius: 'medium',
        color: 'secondary',
        display: css.value('flex'),
        justifyContent: css.value('center'),
        alignItems: css.value('center'),
        height: css.value('$space.1000'),
        position: css.value('absolute'),
        zIndex: css.value('1000'),
        borderStyle: css.value('dashed'),
        borderWidth: css.value('3px'),
        borderColor: 'neutral',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Icon icon={doc} size="medium" css={{marginRight: 'small'}} />
      <view.p css={{font: 'lead'}}>
        {intl.formatMessage(messages.dropFile)}
      </view.p>
    </view.div>
  );
};
